import React from "react";
import PlantGrowthRegulator from "./PlantGroth";

function page(){
    return(

        <>
        <PlantGrowthRegulator />
        </>

    );
}
export default page;